import { Box } from '@mui/material';
import { StyledTitle, editIconBox } from './style';
import { EditIcon } from 'src/assets/icons/EditIcon';

type Props = {
  title: string;
  iconSize?: number;
  greyColor: string;
  isTitleEditable?: boolean;
  isMobile?: boolean;
  isDesktop?: boolean;
  toggleEditHandler: (title: string | null) => void;
};

export const DisplayTitleBox = ({
  title,
  iconSize = 22,
  greyColor,
  isMobile = false,
  isDesktop = false,
  isTitleEditable = true,
  toggleEditHandler,
}: Props) => (
  <Box
    data-sm="report-name"
    sx={{
      display: 'flex',
      position: 'absolute',
      alignItems: 'center',
      width: `calc(100vw -  ${isMobile ? 245 : isDesktop ? 680 : 400}px)`,
      height: '29px',
    }}
  >
    <StyledTitle sx={{ overflow: 'hidden' }}>{title}</StyledTitle>
    {isTitleEditable && (
      <Box sx={editIconBox} onClick={() => toggleEditHandler(null)} data-testid="edit-icon-box">
        <EditIcon width={iconSize} height={iconSize} fill={greyColor} />
      </Box>
    )}
  </Box>
);
